import React from 'react';
import { Fab, CircularProgress } from '@mui/material';
import { DeleteOutlineOutlined } from '@mui/icons-material';

import { primaryBlue } from 'utils/color-styles';

import { FileWithMeta } from './FilesUpload';

interface Props {
  fileWithMeta?: FileWithMeta;
  fileUrl?: string | null;
  onDelete: () => void;
}

export const ImagePreview = ({ fileWithMeta, fileUrl, onDelete }: Props) => (
  <>
    <div
      style={{
        height: 140,
        width: 140,
        position: 'relative',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        flexGrow: 1,
      }}
    >
      {fileWithMeta && fileWithMeta.status === 'uploading' ? (
        <CircularProgress size={33} style={{ padding: 6 }} />
      ) : (
        <div
          style={{
            position: 'relative',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <img
            style={{
              objectFit: 'contain',
              height: '100%',
              width: '100%',
              border: 'none',
              borderRadius: 0,
            }}
            src={fileWithMeta?.publicUrl || fileUrl || undefined}
            alt=""
          />

          {!fileUrl && (
            <Fab
              size="small"
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
                color: primaryBlue,
                background: 'transparent',
                border: `1px solid rgba(81, 40, 170, 0.30)`,
                boxShadow: 'none',
              }}
              onClick={() => {
                onDelete();
              }}
            >
              <DeleteOutlineOutlined />
            </Fab>
          )}
        </div>
      )}
    </div>
  </>
);
